<template>
  <table class="striped_table w-100">
    <tbody v-if="fullShow">
    <tr>
      <td><label>{{ $t('generic.id') }}</label></td>
      <td>{{ details.id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.accountID') }}</label></td>
      <td>
        {{ details.account_id }}
      </td>
    </tr>
    </tbody>
    <data-view :details="details.data" />
    <tbody v-if="fullShow">
    <tr>
      <td><label>{{ $t('generic.createdBy') }}</label></td>
      <td>{{ details.created_by }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.created') }}</label></td>
      <td>{{ details.created_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updatedBy') }}</label></td>
      <td>{{ details.modified_by }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updated') }}</label></td>
      <td>{{ details.updated_at | time }}</td>
    </tr>
    </tbody>
  </table>
</template>
<script>
import DataView from './DataView'
export default {
  name: 'AccountAdditionalDetailsTable',
  components: {
    DataView
  },
  props: {
    details: {
      type: Object,
      required: true,
    },
    fullShow: {
      type: Boolean,
      required: true,
    },
  },
  computed: {}
};
</script>
<style></style>
